import React, { useState, useEffect, useRef } from "react";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import { fetch } from "pdf-lib/cjs/utils";
import {
  PDFViewer,
  Document,
  Page,
  Image,
  Text,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import Cu from "../../assets/images/cu-logo-head.png";
import CuTree from "../../assets/images/cu-logo-tree-foot.png";
import CuFoot from "../../assets/images/cu-logo-foot.png";
import html2canvas from "html2canvas";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getIncomingApplicationById } from "../../Pages/CertifierDashboard/CertifierSlice";
import { Box } from "@chakra-ui/react";
import moment from "moment";
import isAllowed from "../../routing/isAllowed";
import { Loader } from "../../assets/svgs/Icons";
import { listRcs } from "../../api";
import watermarkImage from "../../assets/Sample format-1.png";
import MyBoldFont from "../../assets/Lato-Black.ttf";
import MyBoldFontNew from "../../assets/Lato-Bold.ttf";
import RobotoBold from "../../assets/Roboto-Bold.ttf";
import bgimage from "../../assets/Sample format-1.png";
import Draft from "../../assets/images/resources/draft.png";

Font.register({
  family: "MyFont",
  src: MyBoldFontNew,
});

Font.register({
  family: "Test",
  fonts: [
    {
      src: "https://fonts.googleapis.com/css2?family=Roboto:wght@700",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

// Font.register({
//   family: "CourierPrime",
//   src: CourierItalic,
//   fontWeight: "bold"
// })

Font.register({
  family: "Roboto",
  src: RobotoBold,
  fontWeight: "normal",
});

Font.registerHyphenationCallback((word) => [word]);

const styles = StyleSheet.create({
  document: {
    display: "flex",
  },
  page: {
    flexDirection: "row",
    backgroundColor: "#fff",
    // backgroundImage: `url(${bgimage})`,
  },
  pageBackground: {
    position: "absolute",
    minWidth: "100%",
    minHeight: "100%",
    height: "150%",
    width: "100%",
    display: "block",
    zIndex: 100000,
    top: -15,
    opacity: 0.5,
  },
  pageWrapper: {
    paddingBottom: 200,
    marginTop: 15,
    paddingTop: 15,
  },
  header: {
    position: "absolute",
    top: 5,
    left: 0,
    right: 0,
    height: 140,
    color: "#737373",
  },
  content: {
    position: "absolute",
    top: 145,
    left: 0,
    right: 0,
    padding: 15,
  },
  footer: {
    position: "absolute",
    height: 190,
    bottom: 10,
    left: 0,
    right: 0,
    color: "#737373",
  },

  table: {
    display: "table",
    width: "auto",
    marginTop: "25px",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "black",
  },
  tableHead: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "black",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "black",
  },
  tableCol: {
    width: "35%",
    borderRightWidth: 1,
    borderRightColor: "black",
    padding: 5,
  },
  tableCell: {
    margin: "auto",
    fontSize: 10,
    padding: 2,
  },
  tableHeading: {
    margin: "auto",
    fontSize: 10,
    fontWeight: "bold",
    padding: 2,
  },
  watermark: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    opacity: 0.6,
  },
});

// header code

const MyHeader = ({ application }) => {
  return (
    <View style={styles.header} fixed>
      <View>
        {application?.company_programs &&
        application?.company_programs.length > 0 ? (
          application?.company_programs.map((program) => (
            <Image
              key={program.id}
              src={program.logoImage}
              alt={program.name}
              style={{ width: "60", height: "60", margin: "auto" }}
            />
          ))
        ) : (
          <Image
            src={Cu}
            style={{ width: "60", height: "60", margin: "auto" }}
          />
        )}
      </View>

      <View
        style={{
          marginTop: "5px",
          fontSize: "12px",
          paddingHorizontal: "30",
        }}
      >
        <Text style={{ margin: "auto" }}>
          CU Inspections &amp; Certifications India Pvt. Ltd.{" "}
        </Text>
        <Text
          style={{ textAlign: "center", margin: "auto", paddingTop: "5px" }}
        >
          2nd Floor, Arihant Aura, TTC Industrial Area, Turbhe MIDC, Opposite
          Turbhe Station, 400705, Navi Mumbai, Maharashtra, India
        </Text>
        <Text style={{ margin: "auto", paddingTop: "5px" }}>
          +91 22 61294200
        </Text>
        <Text style={{ margin: "auto", paddingTop: "3px" }}>
          www.petersoncontrolunion.com
        </Text>
      </View>
    </View>
  );
};

// footer code

const MyFooter = ({ application }) => {
  return (
    <View style={styles.footer} fixed>
      <View
        style={{
          width: "100%",
          height: "1px",
          border: "1 solid black",
        }}
      ></View>
      <View
        style={{
          flexDirection: "row",
          fontSize: "11px",
          marginTop: "7",
          paddingHorizontal: "40",
          justifyContent: "space-evenly",
        }}
      >
        <View>
          <Text>Place and date</Text>
          <Text
            style={{
              marginTop: "3pt",
            }}
          >
            India, {moment(application?.issueDate).format("DD-MM-yyyy")}
          </Text>
        </View>

        <View>
          <Text>Name of Authorised Person</Text>
          <Text
            style={{
              fontSize: "6pt",
            }}
          >
            (On behalf of the managing Director)
          </Text>
          <Text
            style={{
              marginTop: "5pt",
            }}
          >
            {application?.approvedBy}
          </Text>
        </View>

        <View>
          <Text>Stamp of the issuing body</Text>
          {/* <Text
            style={{
              marginTop: "15pt",
            }}
          >
            On behalf of the managing Director
          </Text> */}
        </View>
      </View>

      <View
        style={{
          flexDirection: "row",
          fontSize: "11px",
          marginTop: "20px",

          paddingRight: "50",
          justifyContent: "space-evenly",
        }}
      >
        <View>
          <Image src={Cu} style={{ width: "50", height: "50" }} />
        </View>
        <View>
          <Image src={CuFoot} style={{ width: "150", height: "50" }} />
        </View>
        <View>
          <Image
            src={CuTree}
            style={{ width: "50", height: "50", marginRight: "30px" }}
          />
        </View>
      </View>

      <View
        style={{
          marginTop: "15px",
          fontSize: "8px",
          textAlign: "center",
          paddingHorizontal: "40",
        }}
      >
        <Text>
          This electronically issued document is the valid original version.
          This Scope Certificate provides no proof that any goods delivered by
          its holder are {application?.program?.name} certified. Proof of{" "}
          {application?.program?.name} certification of goods delivered is
          provided by a valid Transaction Certificate (TC) covering them.
        </Text>
      </View>
    </View>
  );
};

const MyDocument = ({ application }) => {
  const PageWrapper = ({ children }) => {
    return (
      <Page size="Letter" style={styles.pageWrapper}>
        {application?.approvedBy ? (
          <Image src={bgimage} style={styles.pageBackground} fixed />
        ) : (
          <Image src={Draft} style={styles.pageBackground} fixed />
        )}
        <MyHeader application={application} />
        <View style={styles.content}>{children}</View>
        <MyFooter application={application} />
      </Page>
    );
  };

  return (
    <Document>
      <PageWrapper>
        <View style={{ color: "#737373" }}>
          <View style={{ textAlign: "center" }}>
            <Text
              style={{
                fontSize: "18px",
                fontFamily: "MyFont",
                fontWeight: "medium",
              }}
            >
              Registration Certificate
            </Text>
            <Text style={{ marginTop: "1px", fontSize: "12px" }}>
              {" "}
              Scope Certificate No: {application?.rcNumber}
            </Text>
          </View>
          <View style={{ textAlign: "center", marginTop: "20px" }}>
            <Text
              style={{
                fontSize: "11px",
              }}
            >
              Control Union Certifications declares that
            </Text>
            <Text
              style={{
                fontSize: "18px",
                color: "blue",
                marginTop: "5px",
                fontFamily: "MyFont",
              }}
              render={() => {
                return application?.name;
              }}
            >
              {" "}
            </Text>
            <Text
              style={{
                fontSize: "12px",
                marginTop: "5px",
              }}
            >
              License Number: {application?.licenceNumber}
            </Text>
            <Text
              style={{ fontSize: "12px", marginTop: "5px" }}
              // render={() => application?.address?.raw_address, application?.address?.city}
              render={() => (
                <>
                  {`${application?.address?.raw_address}, ${application?.address?.city}, ${application?.address?.state}, ${application?.address?.country}, ${application?.address?.pinCode}`}
                </>
              )}
            >
              Address of the Organization
            </Text>
          </View>
          <View
            style={{
              width: "50%",
              textAlign: "center",
              justifyContent: "center",
              margin: "auto",
              height: "1px",
              border: "0.1 solid black",
            }}
          ></View>
          <View style={{ marginTop: "15px", textAlign: "center" }}>
            <Text style={{ fontSize: "14px" }}>
              has been inspected and assessed in accordance with the
            </Text>
            <Text
              style={{
                fontSize: "22px",
                marginTop: "5px",
                fontFamily: "MyFont",
                fontWeight: "bold",
              }}
              render={() => {
                return application?.program?.name + " (version 1.0)";
              }}
            ></Text>
          </View>
          <View
            style={{
              textAlign: "center",
              marginTop: "15px",
              paddingHorizontal: "40",
            }}
          >
            <Text style={{ fontSize: "10px" }}>
              and that products of the categories as mentioned below (and
              further specified in the annex) comply with this standard:
            </Text>
            <Text
              style={{ fontSize: "17px", marginTop: "2px", fontWeight: "800" }}
            >
              Product categories:
            </Text>
          </View>
          <View>
            <Text
              style={{
                fontSize: "12px",
                marginTop: "2px",
                textAlign: "center",
              }}
              render={() => {
                const categories = new Set();
                application?.products?.forEach((product) => {
                  categories.add(product?.product_productCategory?.name);
                });
                return Array.from(categories).join(", ");
              }}
            ></Text>
          </View>
          <View
            style={{
              marginTop: "15px",
              fontSize: "10px",
              textAlign: "center",
              paddingHorizontal: "10",
            }}
          >
            <Text>
              Processing steps / activities carried out under responsibility of
              the above-mentioned company (by the operations as detailed in the
              annex) for certified product
            </Text>

            <Text
              style={{
                fontSize: "10px",
                marginTop: "8px",
              }}
              render={() => {
                return application?.processes
                  ?.map((process) => {
                    return process?.name;
                  })
                  .join(", ");
              }}
            ></Text>
          </View>
          <View
            style={{
              marginTop: "13px",
              fontSize: "11px",
              textAlign: "center",
            }}
          >
            <Text>This certificate is valid from</Text>
            <Text style={{ marginTop: "5px" }}>
              {moment(application?.issueDate).format("DD-MM-yyyy")}
            </Text>
            <Text style={{ marginTop: "5px" }}>
              This certificate is valid until
            </Text>
            <Text style={{ marginTop: "5px" }}>
              {moment(application?.expiryDate).format("DD-MM-yyyy")}
            </Text>
          </View>

          <View
            style={{
              paddingHorizontal: "50",
              padding: "3px",
              marginTop: "5px",
            }}
          >
            <View
              style={{
                fontSize: "15px",
                fontWeight: "900",
                textAlign: "left",
                marginTop: "10px",
              }}
              wrap={false}
            >
              {/* Note:Custom fonts need atleast 1 parent element to have that font */}
              <Text
                style={{
                  fontSize: "20px",
                  marginTop: "5px",
                  fontFamily: "Roboto",
                  fontWeight: "700",
                }}
                render={() => {
                  return application?.program?.name + " v1.0";
                }}
              ></Text>
            </View>
            <View
              style={{
                marginTop: "10px",
                fontSize: "12px",
              }}
            >
              <Text>
                Products Annex to certificate no. {application?.rcNumber}
              </Text>
              <Text style={{ marginTop: "10px" }}>
                In specific the certificate covers the following products:
              </Text>
            </View>
            <View
              render={() => {
                const tableRows = application?.products?.map((product, i) => {
                  return (
                    <View style={styles.tableRow} key={i}>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                          {product?.product_productCategory?.name}
                        </Text>
                      </View>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                          {product?.product_productClassification?.name}
                        </Text>
                      </View>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                          {product?.composition.join(", ")}
                        </Text>
                      </View>
                    </View>
                  );
                });

                return (
                  <View>
                    <View style={styles.table} wrap>
                      <View style={styles.tableHead}>
                        <View style={styles.tableRow}>
                          <View style={styles.tableCol}>
                            <Text style={styles.tableHeading}>
                              Product Category
                            </Text>
                          </View>
                          <View style={styles.tableCol}>
                            <Text style={styles.tableHeading}>
                              Product Details
                            </Text>
                          </View>
                          <View style={styles.tableCol}>
                            <Text style={styles.tableHeading}>
                              Material Composition
                            </Text>
                          </View>
                        </View>
                      </View>
                      {tableRows}
                    </View>
                  </View>
                );
              }}
            ></View>

            <View style={{ marginTop: "20px", fontSize: "12px" }}>
              <Text>
                Facility Annex to certificate no {application?.rcNumber}
              </Text>
              <Text style={{ marginTop: "5pt" }}>
                Under the scope of this certificate the following facilities /
                subcontractors have been inspected and assessed. The listed
                processing steps/activities comply with the corresponding
                criteria of the <Text>{application?.program?.name}</Text>
                for the certified products:
              </Text>
            </View>
            {/* Table 2 */}

            <View
              break
              render={() => {
                const filteredUnits = application?.units?.filter(
                  (unit) => unit?.isAudited
                );
                const tableRows = filteredUnits?.map((unit, i) => {
                  return (
                    <View style={styles.tableRow} key={i}>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>{unit?.name}</Text>
                      </View>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                          {`${unit?.address?.raw_address}, ${unit?.address?.city}, ${unit?.address?.state}, ${unit?.address?.country}, ${unit?.address?.pinCode}`}
                        </Text>
                      </View>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                          {unit?.unit_processes
                            ?.map((process) => {
                              return process?.name;
                            })
                            .join(", ")}
                        </Text>
                      </View>
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                          {unit?.unitType
                            ? unit.unitType.charAt(0).toUpperCase() +
                              unit.unitType.slice(1).toLowerCase()
                            : ""}
                        </Text>
                      </View>
                    </View>
                  );
                });

                return (
                  <View style={styles.table}>
                    <View style={styles.tableHead}>
                      <View style={styles.tableRow}>
                        <View style={styles.tableCol}>
                          <Text style={styles.tableHeading}>
                            Name of facility
                          </Text>
                        </View>
                        <View style={styles.tableCol}>
                          <Text style={styles.tableHeading}>
                            Address of operation
                          </Text>
                        </View>
                        <View style={styles.tableCol}>
                          <Text style={styles.tableHeading}>
                            {" "}
                            Processing steps/activities
                          </Text>
                        </View>
                        <View style={styles.tableCol}>
                          <Text style={styles.tableHeading}>
                            Type of relation
                          </Text>
                        </View>
                      </View>
                    </View>
                    {tableRows}
                  </View>
                );
              }}
            ></View>
          </View>
        </View>
      </PageWrapper>
    </Document>
  );
};

const dedup = (arr, key) => {
  return arr.filter(
    (value, index, self) =>
      index === self.findIndex((t) => t[[key]] === value[[key]])
  );
};

const normalizeApplication = (app) => {
  if (!app) return app;
  if (app.company_programs) return app; // already in expected shape, pass through

  const programs = app.applicationForm_programs ?? [];

  // Build a map: mongo _id -> program, so product.program (_id string) can be matched
  // Also normalize each program to have both .id and ._id pointing to the mongo _id
  // so selectedProgram (set from program._id) matches product.program and unit_programs
  const normalizedPrograms = programs.map((p) => ({
    ...p,
    _id: p._id, // mongo _id e.g. "63dcb05fe4bda7a6b1413bbb"
    id: p._id, // override short id ("GCC") with mongo _id so everything matches
    shortId: p.id, // keep "GCC" accessible if needed elsewhere
  }));

  const normalizedUnits = (app.application_units ?? []).map((unit) => ({
    ...unit,
    unit_programs:
      unit.unit_programs?.map((p) => ({
        ...p,
        _id: p._id,
        id: p._id, // same override so unit filter matches selectedProgram
        shortId: p.id,
      })) ?? [],
  }));

  const normalizedProducts = (app.products ?? []).map((p) => ({
    ...p,
    product_productCategory: p.productCategory,
    product_productClassification: p.productClassification,
    product_certifiedLabelGrade: p.certifiedLabelGrade,
    // product.program is already the mongo _id string, so no change needed
  }));

  return {
    ...app,
    company_programs: normalizedPrograms,
    company_units: normalizedUnits,
    company_products: normalizedProducts,
    company_approvedBy: app.application_approvedBy ?? null,
    license: app.applicationForm_company?.license ?? app.license ?? null,
  };
};

const RegistrationCert = ({
  isLoading,
  setIsLoading,
  isPreview,
  application,
  parent,
  companyId,
}) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [rcs, setRcs] = useState([]);
  const [selectedRc, setSelectedRc] = useState(null);
  const [filteredApplication, setFilteredApplication] = useState(null);
  const [programOptions, setProgramOptions] = useState([]);
  const [rcOptions, setRcOptions] = useState([]);

  console.log(application, "res");

  const { application: rcScopeApplication } = useSelector(
    (state) => state.certifier
  );
  console.log(rcScopeApplication);

  const getApplicationData = (id) => {
    try {
      setIsLoading(true);
      dispatch(
        getIncomingApplicationById(parent === "scopeExt" ? companyId : id)
      );
      setIsLoading(false);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getRcData = async () => {
    try {
      if (application) {
        const rcData = await listRcs({
          company: application?.companyId
            ? application?.companyId
            : application?._id,
        });
        console.log(rcData);
        setRcs(rcData);
        setSelectedRc(rcData?.[0]);
        setSelectedProgram(rcData?.[0]?.program);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const programSource = normalizeApplication(
      parent === "scopeExt" ? rcScopeApplication : application
    );
    const programOptions = programSource?.company_programs?.map(
      (program, i) => {
        return (
          <option key={i} value={program._id}>
            {program.name}
          </option>
        );
      }
    );

    setProgramOptions(programOptions);
  }, []);

  useEffect(() => {
    const rcOptions = rcs?.map((rc, i) => {
      return (
        <option key={i} value={rc?.id}>
          {rc?.rc_program?.name} ({rc?.id})
        </option>
      );
    });

    setRcOptions(rcOptions);
  }, [rcs]);

  const selectRc = (rcId) => {
    const currentRc = rcs.find((rc) => rc.id === rcId);
    setSelectedRc(currentRc);
  };

  useEffect(() => {
    getApplicationData(encodeURIComponent(id));
    if (!isPreview) {
      getRcData();
    }
  }, []);

  useEffect(() => {
    const programSource = normalizeApplication(
      parent === "scopeExt" ? rcScopeApplication : application
    );
    if (application || rcScopeApplication) {
      setSelectedProgram(programSource?.company_programs?.[0]?._id);
    }
  }, [application]);

  useEffect(() => {
    const programSource = normalizeApplication(
      parent === "scopeExt" ? rcScopeApplication : application
    );
    setSelectedProgram(programSource?.company_programs?.[0]?.id);
  }, []);

  useEffect(() => {
    if (selectedRc) {
      setSelectedProgram(selectedRc?.program);
    }
  }, [selectedRc]);

  useEffect(() => {
    setSelectedProgram(selectedRc?.program);
  }, []);

  useEffect(() => {
    const programSource = normalizeApplication(
      parent === "scopeExt" ? rcScopeApplication : application
    );
    if (application || rcScopeApplication) {
      let applicationObject = {
        name: programSource?.name,
        address: programSource?.address,
        issueDate:
          isPreview || !selectedRc
            ? new Date().toISOString()
            : selectedRc.initiationDate,
        expiryDate:
          isPreview || !selectedRc
            ? moment().add(1, "year").toISOString()
            : selectedRc.expireAt,
        rcNumber: isPreview ? "CU XXXXXXXXX" : selectedRc?.id,
        licenceNumber: programSource?.license,
        approvedBy: programSource?.company_approvedBy?.name,
      };

      applicationObject.units = programSource?.company_units?.filter((unit) => {
        return unit?.unit_programs.some(
          (program) =>
            program.id === selectedProgram || program._id === selectedProgram
        );
      });

      applicationObject.program = programSource?.company_programs?.find(
        (program) =>
          program.id === selectedProgram || program._id === selectedProgram
      );

      applicationObject.products = programSource?.company_products?.filter(
        (product) => product?.program === selectedProgram
      );

      applicationObject.products = applicationObject?.products?.map(
        (product) => {
          let data = { ...product };
          data.composition = [];
          data?.product_certifiedLabelGrade?.commodities?.forEach(
            (commodity) => {
              data?.composition?.push(commodity?.commodityId?.name);
            }
          );

          data?.ncProductComposition?.map((ncComposition) => {
            data?.composition?.push(ncComposition?.commodity?.name);
          });

          return data;
        }
      );

      applicationObject.processes = [];

      applicationObject?.units?.forEach((unit) => {
        applicationObject?.processes?.push(...unit.unit_processes);
      });

      applicationObject.processes = Array.from(
        new Set(applicationObject?.processes)
      );

      applicationObject.processes = dedup(applicationObject?.processes, "_id");

      setFilteredApplication(applicationObject);
    }
  }, [selectedProgram, selectedRc]);

  return (
    <Box height={"20px"}>
      {isPreview ? (
        <Box padding={"5px"}>
          Select Program &nbsp;
          <select onChange={(e) => setSelectedProgram(e.target.value)}>
            {programOptions}
          </select>
        </Box>
      ) : (
        <Box padding={"5px"}>
          Select Rc &nbsp;
          <select onChange={(e) => selectRc(e.target.value)}>
            {rcOptions}
          </select>
        </Box>
      )}
      <hr></hr>
      <div style={{ height: "100vh" }}>
        {isLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
          >
            <Loader width="50px" height="50px" color="#3958DC" />
            <Text marginLeft="10px">Loading the RC...</Text>
          </Box>
        ) : (
          <PDFViewer
            style={{ width: "100%", height: "100%", marginTop: "1rem" }}
          >
            <MyDocument application={filteredApplication} />
          </PDFViewer>
        )}
      </div>
    </Box>
  );
};

export default isAllowed(RegistrationCert);
